import { useEffect, useState } from 'react';
import { motion } from 'framer-motion';

import { IProductPageViewModel } from 'Scripts/Types/Litium';

import { ISlideModel } from './ProductGalleryContainer';

interface IProductDetailPageGalleryViewProps {
    amountOfSlides: number;
    galleryRef: any;
    slides: ISlideModel[];
    MotionProductGalleryImage: any;
    translations: IProductPageViewModel['translations'];
    triggerSwiperMode: (id: string) => void;
    setCanInteract: () => void;
    srcSetSizesTwoInRow: any;
    srcSetSizesThreeInRow: any;
    srcSetSizesSixInRow: any;
    swiperMode: boolean;
    sliderActive: boolean;
    animationDurationReset: number;
    animationDuration: number;
    maxAmountOfThumbnails: number;
}

export const ProductDetailPageGalleryView = ({
    amountOfSlides,
    galleryRef,
    slides,
    MotionProductGalleryImage,
    translations,
    triggerSwiperMode,
    srcSetSizesTwoInRow,
    srcSetSizesThreeInRow,
    srcSetSizesSixInRow,
    setCanInteract,
    swiperMode,
    sliderActive,
    animationDurationReset,
    animationDuration,
    maxAmountOfThumbnails,
}: IProductDetailPageGalleryViewProps) => {
    const [currentAmountOfThumbnails, setCurrentAmountOfThumbnails] = useState(
        maxAmountOfThumbnails
    );

    const [showAllThumbnails, setShowAllThumbnails] = useState(
        slides.length <= maxAmountOfThumbnails
    );

    useEffect(() => {
        setShowAllThumbnails(slides.length <= maxAmountOfThumbnails);
        setCurrentAmountOfThumbnails(maxAmountOfThumbnails);
    }, [slides]);

    return (
        <motion.div layout key="galleryView">
            <motion.div
                layout
                className={`grid w-full ${
                    amountOfSlides === 1 ? 'grid-cols-6' : 'grid-cols-12'
                } gap-6`}
                ref={galleryRef}
                key="galleryRef"
            >
                {slides
                    .slice(0, currentAmountOfThumbnails)
                    .map((obj, index) => (
                        <div
                            key={`motionGalleryImageWrapper-${obj.id}`}
                            className={`${
                                index > 4
                                    ? 'col-span-2'
                                    : amountOfSlides == 3 || amountOfSlides == 4
                                      ? 'col-span-6'
                                      : index < 2
                                        ? 'col-span-6'
                                        : 'col-span-4 h-auto max-w-[100%]'
                            }`}
                        >
                            <MotionProductGalleryImage
                                expandToSlider={translations.expandToSlider}
                                data={obj}
                                onClickHandler={() => triggerSwiperMode(obj.id)}
                                srcSetSizes={
                                    index > 4
                                        ? srcSetSizesSixInRow
                                        : amountOfSlides == 3 ||
                                            amountOfSlides == 4
                                          ? srcSetSizesTwoInRow
                                          : index > 2
                                            ? srcSetSizesTwoInRow
                                            : srcSetSizesThreeInRow
                                }
                                key={`motionGalleryVideoImage-${obj.id}`}
                                layoutId={obj.id}
                                onLayoutAnimationComplete={() => {
                                    setCanInteract();
                                }}
                                disabled={swiperMode || amountOfSlides < 2}
                                layout
                                transition={{
                                    duration: sliderActive
                                        ? animationDurationReset
                                        : animationDuration,
                                }}
                            />
                        </div>
                    ))}
                {!showAllThumbnails && (
                    <button
                        className="col-span-12 m-auto max-w-10 cursor-pointer"
                        onClick={() => {
                            setCurrentAmountOfThumbnails(slides.length);
                            setShowAllThumbnails(true);
                        }}
                    >
                        <p className="align-center flex justify-center font-roboto text-lg">
                            +{slides.length - maxAmountOfThumbnails}
                        </p>
                    </button>
                )}
            </motion.div>
        </motion.div>
    );
};
